/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 22/01/2025
*/

import * as React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import Styles from "./ourProducts.module.css";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import DemoBtnDialog from '../../components/contact/demoBtnDialog';
import Box from '@mui/material/Box';

import { useNavigate } from 'react-router-dom';

const products = [
    {
        
        subtopic: "E-com Smart",
        link: "/ecom",
        text: "E-commerce platform for unlimited number of products with a convenient shopping experience. Ex: Clothing, Furniture, Grocery, Toys, etc.",
        descrip: "E-commerce platform for unlimited number of products with a convenient shopping experience. Ex: Clothing, Furniture, Grocery, Toys, etc.",
        gradient: "linear-gradient(90deg, #0D72CD 0%, #1CA9C9 100%)"
    },
    {
        
        subtopic: "E-com Lite",
        link: "/ecomlite",
        text: "Stunning website with an e-commerce platform for customisable products on the go. Ex: Floral, Hampers & Gifts, etc.",
        descrip: "Stunning website with an e-commerce platform for customisable products on the go. Ex: Floral, Hampers & Gifts, etc.",
        gradient: "linear-gradient(90deg, #074074 0%, #0D72CD 100%)"
    },
    {
    
        subtopic: "E-Service",
        link: "/eservice",
        text: "A platform to scale up a business with services for online customers Ex: Cleaning service, Grooming Service, Car wash, etc.",
        descrip: "A platform to scale up a business with services for online customers Ex: Cleaning service, Grooming Service, Car wash, etc.",
        gradient: "linear-gradient(90deg, #170E13 0%, #7A7ADB 100%)"
    },
    {
     
        subtopic: "IWMS",
        link: "/ims",
        text: "A smart system for inventory & warehouse management.",
        descrip: "A smart system for inventory & warehouse management.",
        gradient: "linear-gradient(90deg, #4B0082 0%, #0892D0 100%)"
    },
     {
       
        subtopic: "POS",
        link: "/pos",
        text: "A system for a physical shop automating sales with stocks.",
        descrip: "A system for a physical shop automating sales with stocks.",
        gradient: "linear-gradient(90deg, #090947 0%, #5A585A 100%)"
    },
    {
     
        subtopic: "IMS",
        link: "/stock",
        text: "A tracking system to communicate issues & solutions in a business.",
        descrip: "A tracking system to communicate issues & solutions in a business.",
        gradient: "linear-gradient(90deg, #20A4F3 0%, #182B3A 100%)"
    },
    {
        
        subtopic: "CRMS",
        link: "/crm",
        text: "A smart system to manage relationships with leads",
        descrip: "A smart system to manage relationships with leads",
        gradient: "linear-gradient(90deg, #0D72CD 0%, #0F52BA 100%)"
    },
    
    {
      
        subtopic: "HRMS",
        link: "/hr",
        text: "An advanced system to mange human resources strategically.",
        descrip: "An advanced system to mange human resources strategically.",
        gradient: "linear-gradient(90deg, #0D0A0B 0%, #009FC2 100%)"
    },
    {
       
        subtopic: "PMS",
        link: "/payroll",
        text: "A system to manage payroll effectively & efficiently.",
        descrip: "A system to manage payroll effectively & efficiently.",
        gradient: "linear-gradient(90deg, #4B0082 0%, #0892D0 100%)"
    },
];

function OurProducts() {

    const navigate = useNavigate()

    return (
        <div className={Styles.ourProductStaticBg}>
            <div className={`${Styles.outerContainer}`}>
                <Typography className={Styles.topic}>Our Products</Typography>
                <Typography className={Styles.description} >Our advanced digital solutions cater various business needs. The e-commerce web and mobile applications(E-com Smart & E-com Lite) offer a seamless shopping experience for online customers. The Human Resources Management System(HRMS) enhances productivity, while the Issue Management System(IMS) streamlines issue resolution. The Customer Relations Management System(CRMS) improves customer interactions, and the Payroll Management System(PMS) simplifies payroll management. Additionally, our e-commerce and e-services platforms, Inventory & Warehouse Management System(IWMS), and Point Of Sales System(POS) optimise operations and transactions effectively and efficiently.</Typography>
                <Grid container spacing={3} justifyContent="left">
                    {products.map((product, index) => (

                        <Grid item xs={12} sm={6} md={4} key={index}>

                            <Card sx={{ 
                                maxWidth: 345, 
                                borderRadius: 3, 
                                height: 310,
                                overflow: 'hidden',
                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-8px)',
                                    boxShadow: '0 12px 24px rgba(0,0,0,0.15)'
                                }
                            }}>
                                <Box
                                    sx={{
                                        height: 80,
                                        backgroundImage: product.gradient,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        position: 'relative',
                                        overflow: 'hidden'
                                    }}
                                >
                                    {/* Subtle decorative elements */}
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: -20,
                                            right: -20,
                                            width: 80,
                                            height: 80,
                                            borderRadius: '50%',
                                            background: 'rgba(255,255,255,0.1)',
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            bottom: -30,
                                            left: -30,
                                            width: 60,
                                            height: 60,
                                            borderRadius: '50%',
                                            background: 'rgba(255,255,255,0.08)',
                                        }}
                                    />
                                    
                                    {/* Title in the colored container */}
                                    <Typography 
                                        variant="h5" 
                                        component="div" 
                                        sx={{ 
                                            fontFamily: "Albert Sans", 
                                            fontWeight: 700,
                                            color: 'white',
                                            textAlign: 'left',
                                            textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                            zIndex: 2,
                                            position: 'relative',
                                            width: '100%',
                                            paddingLeft: 3
                                        }}
                                    >
                                        {product.subtopic}
                                    </Typography>
                                </Box>

                                <CardContent sx={{ 
                                    height: 150, 
                                    display: 'flex', 
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    padding: 3
                                }}>
                                    <Box className={Styles.productCardDescription}>
                                        <Typography 
                                            variant="body1" 
                                            sx={{ 
                                                color: 'text.secondary', 
                                                fontFamily: "Albert Sans", 
                                                fontWeight: 400,
                                                textAlign: 'left',
                                                lineHeight: 1.6
                                            }}
                                        >
                                            {product.text}
                                        </Typography>
                                    </Box>
                                </CardContent>
                                
                                <CardActions className={Styles.cardActionBtnGroup} sx={{ 
                                    padding: '16px 24px', 
                                    justifyContent: 'space-between',
                                    borderTop: '1px solid rgba(0,0,0,0.08)'
                                }}>
                                    <Button 
                                        size="small" 
                                        onClick={() => navigate(product.link)}
                                        sx={{
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            color: 'primary.main',
                                            '&:hover': {
                                                backgroundColor: 'rgba(13, 114, 205, 0.08)'
                                            }
                                        }}
                                    >
                                        More Info
                                    </Button>

                                    <DemoBtnDialog prop={{ text: product.text, descript: product.descrip }} />

                                </CardActions>
                            </Card>

                        </Grid>
                    ))}
                </Grid>

            </div>
        </div>

    );
}

export default OurProducts;